<div class="row">
  <div class="col-12 px-xl-5 mt-5 grillaMovies">
    <div class="row">
      <div class="col-12 my-4">
        <h1 class="text-white font-weight-bolder mb-0">Archivo fílmico</h1>
        <p></p>
        <p class="lead mb-0 animate__animated animate__fadeIn animate__faster" *ngIf="!loading">
          El Archivo Fílmico de Cinemateca Uruguaya custodia la colección más grande que existe de registros y
          producciones
          nacionales. La mayor parte es desconocida para el público uruguayo. Solo las imágenes más emblemáticas como
          los goles
          del Mundial de 1950, el hundimiento del Graf Spee o los desfiles de Carnaval de antaño, son piezas que han
          tenido cierta
          difusión a través de documentales o reportajes televisivos (nacionales e internacionales). Entre los
          materiales que
          preserva el archivo de cinemateca, se encuentran registros, noticieros, entrevistas, cortometrajes y
          largometrajes que
          datan desde 1898. Las imágenes son preservadas en su soporte de origen: fílmico, analógico o digital, en una
          gran
          variedad de formatos. Esta sección de Archivo de la plataforma, permite al usuario el acceso a una selección
          de
          materiales contextualizados, acompañados de un texto informativo en el cual se brinda información sobre su
          origen, su
          época y circunstancias históricas de modo de apoyar su difusión y, en muchos casos, su descubrimiento. Por más
          información contactarse a <a
            href="mailto:archivofilmico@cinemateca.org.uy">archivofilmico@cinemateca.org.uy</a>
        </p>

        <div class="spinner-border mt-2" style="width: 3rem; height: 3rem" role="status" *ngIf="loading">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>
    </div>

    <div class="row grilla animate__animated animate__fadeIn" *ngIf="movies.length > 0 && !loading">
      <div class="col col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let movie of movies">
        <div class="card">
          <app-movie-item class="movie-item" [movie]="movie"></app-movie-item>
        </div>
      </div>
    </div>

    <div class="row p-lg-5" *ngIf="movies.length == 0 && !loading">
      <div class="sinResultado p-lg-5">
        <div class="icono">
          <i class="fas fa-heart-broken"></i>
        </div>
        <p class="text-muted">Archivos fílmicos está vacío.</p>
      </div>
    </div>
  </div>
</div>